import { ModalService, YtNgFrameworkModule, ModalContainerService } from 'yt-ng-framework';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { UserTabUpdateComponent } from './user/user-tab-update.component';
import { UserTabsComponent } from './user/user-tabs.component';
import { UserUpdateComponent } from './user/user-update.component';
import { NgbModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { LookupsModule } from '../lookups/lookups.module';
import { CompanyUpdateComponent } from './company/company-update.component';
import { CompanyTabUpdateComponent } from './company/company-tab-update.component';
import { CompanyTabsComponent } from './company/company-tabs.component';
import { UserroleModalUpdateComponent } from './userrole/userrole-modal-update.component';
import { UserroleUpdateComponent } from './userrole/userrole-update.component';
import { UserroleComponent } from './userrole/userrole.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyEmailUpdateComponent } from './company/company-email/company-email-update.component';
import { CompanyEmailModalUpdateComponent } from './company/company-email/company-email-modal-update.component';
import { CompanyTelefonUpdateComponent } from './company/company-telefon/company-telefon-update.component';
import { CompanyTelefonModalUpdateComponent } from './company/company-telefon/company-telefon-modal-update.component';
import { CompanyZrcModalUpdateComponent } from './company/company-zrc/company-zrc-modal-update.component';
import { CompanyUvozNbsComponent } from './company/company-uvoz-nbs/company-uvoz-nbs.component';
import { OrgjeddefginiUpdateComponent } from './orgjeddefgini/orgjeddefgini-update.component';

import { ProvajderComponent } from './orgjeddefgini/userprovajder/provajder/provajder.component';
import { ProvajderUpdateComponent } from './orgjeddefgini/userprovajder/provajder/provajder-update.component';
import { ProvajderModalUpdateComponent } from './orgjeddefgini/userprovajder/provajder/provajder-modal-update.component';
import { UserprovajderUpdateComponent } from './orgjeddefgini/userprovajder/userprovajder-update.component';
import { UserprovajderUpdateContainerComponent } from './orgjeddefgini/userprovajder/userprovajder-update-container.component';
import { UserprovajderInlineUpdateComponent } from './orgjeddefgini/userprovajder/userprovajder-inline-update.component';
import { OrgjeddefginiTabsComponent } from './orgjeddefgini/orgjeddefgini-tabs.component';
import { OrgjeddefginiTabUpdateComponent } from './orgjeddefgini/orgjeddefgini-tab-update.component';
import { UseripadressUpdateContinerComponent } from './orgjeddefgini/useripadress/useripadress-update-container.component';
import { UseripadressUpdateComponent } from './orgjeddefgini/useripadress/useripadress-update.component';
import { UseripadressInlineUpdateComponent } from './orgjeddefgini/useripadress/useripadress-inline-update.component';
import { PostaviOdgovornoLiceComponent } from './company/postavi-odgovorno-lice/postavi-odgovorno-lice.component';
import { UserNapomenaComponent } from './user-napomena/user-napomena.component';
import { PodesavanjeAkcijaComponent } from './podesavanje-akcija/podesavanje-akcija.component';
import { AkcijaUpdateComponent } from './podesavanje-akcija/akcija/akcija-update.component';
import { AkcijaUpdateModalComponent } from './podesavanje-akcija/akcija/akcija-update-modal.component';
import { DodajRolaActionComponent } from './podesavanje-akcija/dodaj-rola-action/dodaj-rola-action.component';
import { CompanyZrcUpdateComponent } from './company/company-zrc/company-zrc-update.component';
import { CompanyZrcNewTabsComponent } from './company/company-zrc-new/company-zrc-new-tabs.component';
import { CompanyZrcNewTabUpdateComponent } from './company/company-zrc-new/company-zrc-new-tab-update.component';
import { CompanyZrcNewUpdateComponent } from './company/company-zrc-new/company-zrc-new-update.component';
import { InstrukcijaPlacanjaUpdateContainerComponent } from './company/company-zrc-new/instrukcija-placanja-update-container.component';
import { InstrukcijaPlacanjaInlineUpdateComponent } from './company/company-zrc-new/instrukcija-placanja-inline-update.component';
import { InstrukcijaPlacanjaUpdateComponent } from './company/company-zrc-new/instrukcija-placanja-update.component';
import { InstrukcijaPlacanjaModalUpdateComponent } from './company/company-zrc-new/instrukcija-placanja-modal-update.component';









@NgModule({
  imports: [
    CommonModule
    ,NgbModule
    ,LookupsModule
    ,AdminRoutingModule,
    YtNgFrameworkModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  declarations: [HomeComponent
    ,  UserTabsComponent, UserTabUpdateComponent, UserUpdateComponent, AdminComponent
    ,  CompanyUpdateComponent, CompanyTabUpdateComponent, CompanyTabsComponent
    ,  UserroleModalUpdateComponent, UserroleUpdateComponent, UserroleComponent
    ,  CompanyEmailUpdateComponent, CompanyEmailModalUpdateComponent
    ,  CompanyTelefonUpdateComponent, CompanyTelefonModalUpdateComponent
    ,  CompanyZrcUpdateComponent, CompanyZrcModalUpdateComponent
    , CompanyUvozNbsComponent, OrgjeddefginiUpdateComponent, OrgjeddefginiUpdateComponent, OrgjeddefginiUpdateComponent
    , UserprovajderUpdateComponent, UserprovajderUpdateComponent, UserprovajderUpdateContainerComponent, UserprovajderInlineUpdateComponent
    , OrgjeddefginiTabsComponent, OrgjeddefginiTabUpdateComponent
    , ProvajderComponent, ProvajderUpdateComponent,ProvajderModalUpdateComponent, UseripadressUpdateContinerComponent, UseripadressUpdateComponent, 
    UseripadressInlineUpdateComponent, PostaviOdgovornoLiceComponent, UserNapomenaComponent, PodesavanjeAkcijaComponent, AkcijaUpdateComponent, AkcijaUpdateModalComponent, DodajRolaActionComponent,
     CompanyZrcNewTabsComponent,
     CompanyZrcNewTabUpdateComponent,
     CompanyZrcNewUpdateComponent,
     InstrukcijaPlacanjaUpdateContainerComponent,
     InstrukcijaPlacanjaInlineUpdateComponent,
     InstrukcijaPlacanjaUpdateComponent,
     InstrukcijaPlacanjaModalUpdateComponent
  ],
  // entryComponents: [
  //     UserroleModalUpdateComponent
  //     , CompanyEmailModalUpdateComponent
  //     , CompanyTelefonModalUpdateComponent
  //     , CompanyZrcModalUpdateComponent
  //     , CompanyUvozNbsComponent
  //     , PostaviOdgovornoLiceComponent
  //     , UserNapomenaComponent
  //     , DodajRolaActionComponent
     
  //   ],
    exports: [
      UserroleModalUpdateComponent
      , CompanyEmailModalUpdateComponent
      , CompanyTelefonModalUpdateComponent
      , CompanyZrcModalUpdateComponent
    ],
    providers: [
      ModalContainerService,
      ModalService      
      //NgbModal
    ]
})
export class AdminModule { }
